import type { RefineLayoutThemedTitleProps } from '@refinedev/antd';
import { useLink, useRouterContext, useRouterType } from '@refinedev/core';
import { Space, theme } from 'antd';
import React from 'react';

export const CcThemedTitleV2: React.FC<RefineLayoutThemedTitleProps> = ({
  collapsed,
  wrapperStyles,
}) => {
  const { token } = theme.useToken();
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const ActiveLink = routerType === 'legacy' ? LegacyLink : Link;

  return (
    <ActiveLink
      to="/"
      style={{
        display: 'inline-block',
        textDecoration: 'none',
      }}
      data-testid="cc-title"
    >
      <Space
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 'inherit',
          ...wrapperStyles,
          // backgroundColor: token.colorPrimary,
          // backgroundColor: colors['--triad-blue-0'], // TODO: replace with token.colorPrimary after fixing
        }}
      >
        {collapsed ? (
          <img
            src={'/logo-collapsed.svg'}
            alt="CopingCard Logo"
            data-testid="logo-collapsed"
            style={{
              width: '90px',
              height: '95px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 24px',
            }}
          />
        ) : (
          <img
            src={'/logo.svg'}
            alt="CopingCard"
            data-testid="logo-expanded"
            style={{
              width: '200px',
              padding: '12px 24px',
              // padding: '12px 12px',
            }}
          />
        )}
      </Space>
    </ActiveLink>
  );
};
